import { Origin } from "@/constants/share";
import summaryCommonStore from "@/store/summaryCommon.store";
import { IPG } from "@/types/summary";

export function formatOldDetail(oldDetail: IPG[], originType: string) {
   // 重置store avatarMap
   if (originType === Origin.MEETING_PLATE || originType === Origin.PLATE_SHARE) {
    summaryCommonStore.getState().clearAvatar();
  }
  return oldDetail.map((item) => {
    // 兼容大大板端分享过来的数据没有speakerName问题
    const fromSass =
      (!item.speakerName || !item.speakerName.length) && item.roleName;
    item.speakerName = fromSass
      ? [item.roleName]
      : item.speakerName?.[0] === "未知发言人"
      ? ["发言人"]
      : item.speakerName;
    const actualHeadImage = summaryCommonStore.getState().getAvatar(item.roleName);
    item.headImage = fromSass ? actualHeadImage : item.headImage;
    item.useDefaultIcon = fromSass ? true : item.useDefaultIcon;

    item.sc = item.sc.map((sItem) => {
      sItem.words = [
        {
          bt: sItem.bt,
          et: sItem.et,
          word: sItem.tc,
          wi: `w-${sItem.si}`,
          mark: sItem.mark || item.mark,
        },
      ];
      return sItem;
    });
    return item;
  });
}
